module.exports = __webpack_public_path__ + "assets/img/icon_user17.39fb7d6d.png";